import DashboardComponent from './Component';

const Dashboard = () => {
  return <DashboardComponent />
}
export default Dashboard;           
